module.exports = __webpack_public_path__ + "img/map.50ab8d0d.png";